import { put, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import * as actions from '../store/options.actions'
import { getCurrentYear } from '../../../utilities/dateTime.util'

export function* setYearOptions() {
  try {
    const yearOptions = []
    for (let year = getCurrentYear(); year >= 1900; year--) {
      yearOptions.push({
        id: year,
        name: year.toString(),
      })
    }
    yield put(actions.setImmunizationYearOptions(yearOptions))
  } catch (e) {
    yield put(throwPcrException(`setYearOptions() error: ${e}`))
  }
}
export function* setYearOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setYearOptions)
}
